import { createSlice } from '@reduxjs/toolkit';

// initial State of Snackbar
const initialState = {
    open: false,
    message: 'Default Snackbar Message',
    variant: 'solid',
    autoHideDuration: 3000,
    color: 'neutral',
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
    }
};

// creating the reducer function with logic, action and state
const snackbar = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        showSnackbar: (state, action) => {
            const { open, message, variant, autoHideDuration, color, anchorOrigin } =
                action.payload;
            state.open = open || initialState.open;
            state.message = message || initialState.message;
            state.variant = variant || initialState.variant;
            state.color = color || initialState.color;
            state.autoHideDuration = autoHideDuration || initialState.autoHideDuration;
            state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
            // console.log("showSnackbar state: ", JSON.parse(JSON.stringify(state)));
        },
        hideSnackbar: (state) => {
            state.open = false;
            // console.log("hideSnackbar state: ", JSON.parse(JSON.stringify(state)));
        }
    }
});

// export the actions to use it
export const { showSnackbar, hideSnackbar } = snackbar.actions;

export default snackbar.reducer;
